import PropTypes from "prop-types";
import React from "react";
import { graphql } from "gatsby";
import { ThemeContext } from "../layouts";
import Article from "../components/Article";
import Headline from "../components/Article/Headline";
import Seo from "../components/Seo";

const NewsletterPage = props => {
  const {
    data: {
      site: {
        siteMetadata: { facebook }
      }
    }
  } = props;

  return (
    <React.Fragment>
      <ThemeContext.Consumer>
        {theme => (
          <Article theme={theme}>
            <header>
              <Headline title="Newsletter" theme={theme} />
            </header>
            <img className="w-100" src="/images/newsletter_header.jpeg" />
            <h3 className="my-1">TRITON-AI NEWSLETTER IS NOW AVAILABLE FOR SUBSCRIPTION</h3>
            <p className="my-1">
              Triton-Ai is a UCSD organization that specializes in building, training, and
              autonomously driving small scaled cars to compete in racing tournaments. Our mission
              is to help UCSD students have access to AI/robotic opportunities!
            </p>
            <div className="my-1 px-1">
              <ul>
                <li>Triton-Ai club progress, research and tournament opportunities!</li>
                <li>
                  Educational and research based AI information to help establish the AI community
                  at UCSD!
                </li>
                <li>Free DIY robotic/programming workshops!</li>
              </ul>
            </div>
            <h4 className="my-1">Subscribe below!</h4>
            <iframe
              className="my-1 w-100"
              src="https://docs.google.com/forms/d/e/1FAIpQLSf_ZSyXo-eF8rtR98eV4DXKgao6CsvzkhpqxT77ewF4389TVA/viewform?embedded=true"
              height="400"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
            >
              Loading…
            </iframe>
            <p className="my-1">
              If you are interested in becoming a club member then reach out to
              triton-ai@eng.ucsd.edu with a description of your robot/programming experience!
            </p>
          </Article>
        )}
      </ThemeContext.Consumer>

      <Seo facebook={facebook} />

      <style jsx>{`
        .w-100 {
          width: 100%;
        }

        .my-1 {
          margin: 1rem 0;
        }

        .px-1 {
          padding: 0 10px;
        }
      `}</style>
    </React.Fragment>
  );
};

NewsletterPage.propTypes = {
  data: PropTypes.object.isRequired
};

export default NewsletterPage;

//eslint-disable-next-line no-undef
export const query = graphql`
  query NewsletterQuery {
    site {
      siteMetadata {
        facebook {
          appId
        }
      }
    }
  }
`;
